module.exports = __webpack_public_path__ + "static/media/tip-four.7fd93171.png";